import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TreeNode, MessageService } from 'primeng/api';
import { FolderManagementService } from '../../../../framework/services/folder-mgmt.service';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { INPUTMASK_VALUE_ACCESSOR } from 'primeng';
import { AddEngagementMemoryService } from '../../add-engagement-memory-service/add-engagement-memory.service';
import { EngagementManagementService } from 'src/framework/services/engagement-mgmt.service';
import { Router } from '@angular/router';
import { element } from 'protractor';
import { NgxSpinnerService } from 'ngx-spinner'
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';

@Component({
  selector: 'app-folder-structure',
  templateUrl: './folder-structure.component.html',
  styleUrls: ['./folder-structure.component.css']
})
export class FolderStructureComponent implements OnInit {

  foldersList = [];
  selectedFolder: any;

  @Input() treeData: string;
  @Input() big: boolean;

  targetTreeData: any[] = [];

  maxSeed: number = 0;
  languageList: any[];
  languageLabels: any[] = [];
  folderPath: "";
  selectedTargetFile: TreeNode;
  selectedSourceFile: TreeNode;
  globalIdentitySeed: number = 0;
  templateNode: TreeNode[];
  deleteNodeObj: TreeNode;
  isVisible: boolean = false;


  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;

  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;

  @Output() showPreviousControl = new EventEmitter<string>();
  public constructor(private folderService: FolderManagementService,
    private http: HttpClient,
    private addEngagementMemoryService: AddEngagementMemoryService,
    private engagementService: EngagementManagementService,
    private languageSerivce: LanguageService,
    private router: Router,
    private ngxSpinner: NgxSpinnerService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.ngxSpinner.show();
    this.folderService.getFolderTemplate(0).then((value) => {
      if (value && value.length > 0) {
        for (let i = 0; i < value.length; i++) {
          this.foldersList.push(value[i]);
        }
        if (this.addEngagementMemoryService.getFolderTemplate()) {
          this.selectedFolder = JSON.parse(this.addEngagementMemoryService.getFolderTemplate());
          this.targetTreeData = this.selectedFolder.children;
        }
      }
      this.ngxSpinner.hide();
    })
  }

  onFolderSelection(event) {
    let model = this.resetData(event.value)
    this.targetTreeData = model.children.length > 0 ? model.children : [];

  }


  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageSerivce.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

            englishLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

                selectedLangLabelMappings = languageMappings.filter(item =>
                  item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                  && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangLabelMappings = englishLangLabelMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.islabelLoaded = true;
          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }


  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  resetData(model) {
    if (model) {
      let selectedLanguages = this.addEngagementMemoryService.getSelectedLanguages();
      if (model.children && model.children.length > 0) {
        for (let i = 0; i < model.children.length; i++) {
          this.resetData(model.children[i])
        }
      }
      if (model.data && model.data.length == 1) {
        model.data[0].createdDTTM = new Date().toUTCString();
        let languages = [];
        selectedLanguages.forEach(element => {
          languages.push(model.data[0].language.find(t => t.languageId == element.languageId));
        })
        model.data[0].language = languages;
      }
      return model;
    }
  }

  onPreviousButtonClick(ele) {
    let templateToSave: any[] = [];
    templateToSave.push(this.selectedFolder as TreeNode);
    this.addEngagementMemoryService.setFolderTemplate(JSON.stringify(templateToSave[0], this.getCircularReplacer()));
    this.showPreviousControl.emit('contacts');
  }
  saveEngagement() {
    if (!this.selectedFolder) {
      this.messageService.add({
        summary: this.labelReplacer('Pleaseselectfoldertemplate'),
        detail: "",
        sticky: false,
        severity: 'error'
      });
    } else {
      this.ngxSpinner.show();
      let templateToSave: any[] = [];
      templateToSave.push(this.selectedFolder as TreeNode);
      let externalContacts = this.addEngagementMemoryService.getExternalContacts();
      if (externalContacts.length > 0) {
        externalContacts.forEach((t) => {
          t.selectedLogo = {
            value: t.selectedLogo
          }
        })
      }
      let requestObject = {
        'engagementDetails': this.addEngagementMemoryService.getEngagementDetails(),
        'internalContact': this.addEngagementMemoryService.getInteralContact(),
        'externalRoles': this.addEngagementMemoryService.getExternalRole(),
        'externalContacts': this.addEngagementMemoryService.getExternalContacts(),
        'folderTemplate': JSON.stringify(templateToSave, this.getCircularReplacer())
      };

      this.engagementService.addEngagement(requestObject).subscribe((response) => {
        if (response.responseStatus == 1) {
          this.messageService.add({
            summary: this.labelReplacer('ErroroccuredwhileaddingEngagement'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
          this.ngxSpinner.hide();
        } else {
          this.addEngagementMemoryService.resetEngagementMemory();

          this.messageService.add({
            summary: this.labelReplacer('Engagementaddedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          setTimeout(() => {
            this.ngxSpinner.hide();
            this.router.navigate(["/home"], { queryParams: { engagementType: 'active' } })
          }, 3000)
        }
      });
    }
  }

  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };
}
